/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRectangleVerticalFilled = createReactComponent("filled", "rectangle-vertical-filled", "IconRectangleVerticalFilled", [["path", { "d": "M17 2h-10a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z", "key": "svg-0" }]]);

export { IconRectangleVerticalFilled as default };
//# sourceMappingURL=IconRectangleVerticalFilled.mjs.map
